import React, {useEffect} from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import { useConditionalHelper } from '../Conditional';
import { dateTimeToString, numPad } from '../../../Services/helpers';

const DateTime = ({label, name, help, onChange, min, max, step, time, prefix, suffix, disabled, validators, showDatePrompts, defaultNow}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? '';
    const {isValid, error} = useValidators(value, validators, name, updateValidity);

    useConditionalHelper(name);

    const handleChange = (newVal) => {
        updateField(name, newVal);
        onChange && onChange(newVal);
    }

    useEffect(() => {
        if (defaultNow && !value) {
            handleChange(dateTimeToString(new Date(), 'T'));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value, defaultNow]);

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <div className="relative flex flex-row">
            <div className="pointer-events-none inset-y-0 left-0 flex items-center pr-1">
                <span className="fill-gray-400 text-gray-400 sm:text-sm">{prefix}</span>
            </div>

            <input className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
                type={time === false ? 'date' : 'datetime-local'}
                value={value}
                min={min}
                max={max}
                step={step}
                onChange={e => handleChange(e.target.value)}
                disabled={isDisabled}
            />

            <div className="pointer-events-none inset-y-0 right-0 flex items-center pl-1">
                <span className="fill-gray-400 text-gray-400 sm:text-sm">{suffix}</span>
            </div>
        </div>

        {showDatePrompts && <div className="mt-3">
            {dateButton(0, handleChange, value, time)}
            {dateButton(1, handleChange, value, time)}
            {dateButton(2, handleChange, value, time)}
            {dateButton(3, handleChange, value, time)}
            {dateButton(4, handleChange, value, time)}
        </div>}

    </CommonFieldWrapper>
}

const dateButton = (days, handleChange, value, time) => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    const str = date.getUTCFullYear() + '-' + numPad(date.getUTCMonth() + 1) + '-' + numPad(date.getUTCDate());

    let title;
    if (days === 0) {
        title = 'Today';
        // } else if (days === 1) {
        //     title = 'Tomorrow';
    } else {
        title = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][date.getDay()];
    }

    return <button className="btn btn-sm btn-light mr-2"
        onClick={(e) => {
            e.preventDefault();
            if (time === false) {
                handleChange(str);
            } else {
                // In case there's time involved in the value, we want to keep that
                handleChange(value ? value.replace(/\d{4}-\d{2}-\d{2}/, str) : str+'T12:00')
            }
        }}
    >
        {title}
    </button>
}


export default DateTime;
